var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Icon from '../../../Icon';
const IconStationVia = (_a) => {
    var { size, fill } = _a, commonProps = __rest(_a, ["size", "fill"]);
    const iconContent = {
        type: 'svg',
        content: (React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M21.525 12.2175L19.56 10.2825C19.26 9.99 18.675 9.75 18.2625 9.75H12.615V8.25H17.94C18.36 8.25 18.705 7.9125 18.705 7.5V3C18.705 2.5875 18.36 2.25 17.94 2.25H5.7375C5.3175 2.25 4.7325 2.49 4.44 2.7825L2.475 4.7175C2.175 5.01 2.175 5.49 2.475 5.7825L4.44 7.7175C4.74 8.01 5.325 8.25 5.7375 8.25H11.085V9.75H6.06C5.64 9.75 5.295 10.0875 5.295 10.5V15C5.295 15.4125 5.64 15.75 6.06 15.75H11.085V21C11.085 21.4125 11.4225 21.75 11.85 21.75C12.2775 21.75 12.615 21.4125 12.615 21V15.75H18.2625C18.6825 15.75 19.2675 15.51 19.56 15.2175L21.525 13.2825C21.825 12.99 21.825 12.51 21.525 12.2175ZM5.7375 6.75C5.7 6.75 5.55 6.6825 5.4975 6.6375L4.0875 5.25L5.52 3.84C5.52 3.84 5.6925 3.7575 5.76 3.75H17.175V6.75H5.7375ZM18.48 14.16C18.48 14.16 18.3 14.2425 18.2325 14.25H6.825V11.25H18.2625C18.3 11.25 18.45 11.3175 18.5025 11.3625L19.9125 12.75L18.48 14.16Z", fill: "black" }))),
        alt: 'Icon StationVia',
    };
    return React.createElement(Icon, Object.assign({}, commonProps, { source: iconContent, size: size, fill: fill }));
};
export default IconStationVia;
//# sourceMappingURL=index.js.map